export default function Hero() {
  return (
    <section
      id="hero"
      className="relative pt-[64px] md:pt-[72px] min-h-screen flex items-center"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20manga%20illustration%20background%20with%20soft%20gradients%2C%20abstract%20comic%20panel%20textures%20in%20cream%20and%20warm%20beige%2C%20delicate%20line%20art%2C%20Japanese%20manga%20aesthetic%2C%20minimalist%20atmospheric%20composition%2C%20no%20characters%2C%20subtle%20warm%20lighting%2C%20elegant%20storytelling%20mood&width=1600&height=1000&seq=hero-bg-manga&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>韩漫 · 日漫 · 国漫 大全</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-5">
              YY漫画网
              <br className="md:hidden" />
              <span className="text-primary-600"> 免费漫画在线阅读平台</span>
            </h1>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              汇聚韩漫、日漫、国漫精品资源，提供好看的漫画排行榜推荐与智能分类浏览。
              支持全集漫画免费下拉式阅读，热门漫画每日追更，让你随时随地在线看漫画，
              发现下一部值得追的好作品。
            </p>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              本站每日更新，涵盖热血、恋爱、奇幻、悬疑、搞笑、都市等多元题材，
              当前热门连载一网打尽，下拉式阅读体验流畅舒适。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">2000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">部漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">热门漫画追更</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">全免费</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">下拉式阅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-fire-line"></i>
                查看热门榜单
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-300 text-primary-700 font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-compass-3-line"></i>
                按分类浏览
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20artistic%20manga%20illustration%20of%20a%20person%20reading%20comics%20in%20cozy%20atmosphere%2C%20surrounded%20by%20floating%20manga%20pages%20and%20soft%20glowing%20lights%2C%20handdrawn%20Japanese%20manga%20style%2C%20cream%20and%20coral%20warm%20color%20palette%2C%20elegant%20composition%2C%20storytelling%20vibe%2C%20reading%20enthusiast%20scene&width=900&height=1100&seq=hero-manga-visual&orientation=portrait"
                alt="YY漫画网 免费漫画在线阅读 漫画推荐 韩漫日漫国漫"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}